import { memo } from 'react';
import { trans } from '@lingoda/i18n';
import { Grid, Typography } from '@lingoda/ui';

interface Props {
    hasTeacher: boolean;
    classTypeInfo: string;
}

const ClassInfoComponent = ({ classTypeInfo, hasTeacher }: Props) => (
    <>
        <Grid item>
            <Typography
                variant="overline"
                data-cy="classInfo_classTypeInfo"
                htmlColor="text.secondary"
            >
                {classTypeInfo}
            </Typography>
        </Grid>
        {!hasTeacher && (
            <Grid item>
                <Typography variant="overline" htmlColor="text.secondary">
                    {trans('teacher-will-be-assigned', {}, 'student-common')}
                </Typography>
            </Grid>
        )}
    </>
);

export const ClassInfo = memo(ClassInfoComponent);
